import {Component, computed, inject, input} from '@angular/core';
import {Menu} from "primeng/menu";
import {MenuItem} from "primeng/api";
import {NavigationService} from "../../../../core/services/commons/navigation.service";
import {NgStringPipesModule} from "ngx-pipes";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-breadcrumb-item',
  imports: [
    RouterLink,
    NgStringPipesModule,
    Menu
  ],
  templateUrl: './breadcrumb-item.component.html',
  styleUrl: './breadcrumb-item.component.scss'
})
export class BreadcrumbItemComponent {
  public navigationService = inject(NavigationService)

  readonly breadcrumbItem = input.required<any>();

  route = computed(()=>{
    return this.breadcrumbItem()['route']?.replace('#id#', this.navigationService.currentId())
  })

  label = computed(()=>{
    return this.breadcrumbItem()['label']?.replace('#name#', this.navigationService.currentName())
  })

  actions = computed(() => {
    if (!this.breadcrumbItem()['actions']) return undefined;
    return this.breadcrumbItem()['actions'].map((action: any) => {
      return {...action, routerLink: action.routerLink.replace('#id#', this.navigationService.currentId())}
    });
  });

}
